import { jsx as _jsx } from "react/jsx-runtime";
import en from 'date-fns/locale/en-GB';
import ReactDatePicker, { registerLocale } from 'react-datepicker';
import { styled } from 'styled-components';
import { DATE_FORMAT } from './constants.js';
const Wrapper = styled.div `
  .react-datepicker-popper:not(.adnz) {
    .react-datepicker {
      border: none;
      ${({ theme: { shadows } }) => shadows.large};
    }
    .react-datepicker__day--selected,
    .react-datepicker__day--range-end,
    .react-datepicker__day--range-start {
      position: relative;
      background-color: ${({ theme }) => theme.colors.main};
      z-index: 0;
    }

    .react-datepicker__week {
      margin-bottom: 6px;
    }

    .react-datepicker__day--range-start:before,
    .react-datepicker__day--selecting-range-start:before {
      left: 4px;
    }
    .react-datepicker__day--range-end:before {
      right: 4px;
    }

    .react-datepicker__day--in-selecting-range:not(
      .react-datepicker__day--selected,
      .react-datepicker__day--range-end,
      .react-datepicker__day--in-range
    ),
    .react-datepicker__day--in-range:not(.react-datepicker__day--selected, .react-datepicker__day--range-end) {
      background-color: ${({ theme }) => theme.colors.mainLight};
      color: ${({ theme }) => theme.colors.black_3};
    }

    .react-datepicker__day--selected,
    .react-datepicker__day--in-selecting-range,
    .react-datepicker__day--in-range {
      box-shadow: none;
    }

    .react-datepicker__day--range-start.react-datepicker__day--in-range,
    .react-datepicker__day--keyboard-selected.react-datepicker__day--range-start,
    .react-datepicker__day--keyboard-selected.react-datepicker__day--selecting-range-start {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    .react-datepicker__day--range-end.react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range) {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
    .react-datepicker__day--selecting-range-start {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    .react-datepicker__day--selecting-range-end {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }

    .react-datepicker__day-name,
    .react-datepicker__day,
    .react-datepicker__time-name {
      margin: 0;
    }
  }
`;
const DatePickerRange = ({ dateFormat = DATE_FORMAT, onChange, dataTestId, timeFormat, startDate, endDate, ...props }) => {
    const LOCALE = 'en';
    registerLocale(LOCALE, en);
    return (_jsx(Wrapper, { "data-testid": dataTestId, children: _jsx("div", { className: 'react-datepicker-popper', children: _jsx(ReactDatePicker, { disabledKeyboardNavigation: true, locale: LOCALE, timeFormat: timeFormat, dateFormat: dateFormat, selected: startDate, onChange: onChange, startDate: startDate, endDate: endDate, selectsRange: true, inline: true, ...props }) }) }));
};
export { DatePickerRange };
